import Clickoutside from 'element-ui/lib/utils/clickoutside';
import {requestAlert, requestScroll} from "@/iamteacherpc/utils/iframe.js";

export default {
    directives: {Clickoutside},

    data() {
        return {
            activeEditorIndex: -2,
            interactionOnce: false
        }
    },

    methods: {
        onFocusout(event) {
            if (event.relatedTarget && this.$refs.listWrap !== event.relatedTarget && !this.$refs.listWrap.contains(event.relatedTarget)) {
                this.changeToViewerAll();
            }
        },

        changeToViewerAll() {
            if (this.interactionOnce && !this.isStopListChange) {
                this.activeEditorIndex = -1;
            }
        },

        markInteraction() {
            this.interactionOnce = true;
        },

        onChangeActiveEditor(index, questionNo) {
            this.activeEditorIndex = index;

            this.$nextTick(function () {
                if (questionNo) {
                    this.scrollAndFocusQuestionByQuestionNo(questionNo);
                } else {
                    this.scrollAndFocusQuestion(index);
                }
            });
        },

        addQuestion() {
            if (this.questions.length >= this.maxQuestion) {
                this.stopListChange();

                requestAlert({
                    title: this.$t('editorQuestionList_canAddMaxQuestion', {question: this.questionText, max: this.maxQuestion}),
                    okText: this.$t('common_confirm')
                }).then(() => this.listChange());

                return;
            }

            this.storeAddQuestion();
            const lastIndex = this.getLastQuestionIndex();
            this.activeEditorIndex = lastIndex;

            this.$nextTick(function () {
                this.scrollAndFocusQuestion(lastIndex);
            });
        },

        async moveUpQuestion(index) {
            if (index === 0) {
                return;
            }

            const isMove = await this.storeMoveUpQuestion(index);
            if (!isMove) {
                return;
            }

            this.activeEditorIndex = index - 1;

            this.$nextTick(function () {
                this.scrollToEditor(this.getEditor(index - 1));
                this.$refs.upButton[0].focus();
            });
        },

        moveDownQuestion(index) {
            if (index === this.questions.length - 1) {
                return;
            }

            this.storeMoveDownQuestion(index);
            this.activeEditorIndex = index + 1;

            this.$nextTick(function () {
                this.scrollToEditor(this.getEditor(index + 1));
                this.$refs.downButton[0].focus();
            });
        },

        onCopyQuestion() {
            if (this.questions.length >= this.maxQuestion) {
                this.stopListChange();

                requestAlert({
                    title: this.$t('editorQuestionList_canAddMaxQuestion', {question: this.questionText, max: this.maxQuestion}),
                    okText: this.$t('common_confirm')
                }).then(() => this.listChange());

                return;
            }

            const lastIndex = this.getLastQuestionIndex();
            this.activeEditorIndex = lastIndex;

            this.$nextTick(function () {
                this.scrollAndFocusQuestion(lastIndex);
            });
        },

        scrollAndFocusQuestion(index) {
            this.scrollToEditor(this.getEditor(index));
            this.focusQuestion(this.getEditor(index));
        },

        scrollAndFocusQuestionByQuestionNo(questionNo) {
            const editor = document.getElementById(`questionEditor${questionNo}`);
            const scrollTop = editor.offsetTop;
            requestScroll(scrollTop);

            const input = document.getElementById(`q${questionNo}`);
            input.focus();
        },

        scrollToEditor(editor) {
            const scrollTop = editor.$el.offsetTop;
            requestScroll(scrollTop);
        },

        focusQuestion(editor) {
            editor.focusQuestion();
        },

        getLastQuestionIndex() {
            return this.questions.length - 1;
        },

        getEditor(index) {
            return this.$refs[`question:${index}`][0];
        },

        setActiveEditorIndex(index) {
            this.activeEditorIndex = index;
        }
    },

    mounted() {
        this.$eventBus.$on(['parentClick', 'parentFocus'], this.changeToViewerAll);
    },

    beforeDestroy() {
        this.$eventBus.$off(['parentClick', 'parentFocus'], this.changeToViewerAll);
    }
};
